import type { ApiScheduledGame } from "../api";

export function getGameTitle(
  game: Pick<ApiScheduledGame, "team" | "typeEvent" | "typeMatchup">,
) {
  if (game.typeMatchup) {
    const isAway = game.typeMatchup.where === "away";
    const opponentName = game.typeMatchup.opponent.name;
    const teamName = game.team.name;

    return isAway
      ? `${teamName} vs ${opponentName}`
      : `${opponentName} vs ${teamName}`;
  }

  if (game.typeEvent) {
    return game.typeEvent.name;
  }

  throw new TypeError("Missing event or matchup details");
}

export function getGameShortTitle(
  game: Pick<ApiScheduledGame, "team" | "typeEvent" | "typeMatchup">,
) {
  if (game.typeMatchup) {
    const isAway = game.typeMatchup.where === "away";
    const teamAbbreviation = game.team.abbreviation;
    const opponentAbbreviation = game.typeMatchup.opponent.abbreviation;

    return isAway
      ? `${teamAbbreviation} vs ${opponentAbbreviation}`
      : `${opponentAbbreviation} vs ${teamAbbreviation}`;
  }

  if (game.typeEvent) {
    return game.typeEvent.name;
  }

  throw new TypeError("Missing event or matchup details");
}

/**
 * Returns the shortest title for a game, as used at the top of the game page.
 *
 * @example
 * - For a matchup: `@ Opponent` or `vs Opponent`
 * - For an event: `Event Name`
 */
export function getGameShortestTitle(
  game: Pick<ApiScheduledGame, "team" | "typeEvent" | "typeMatchup">,
) {
  if (game.typeMatchup) {
    const isAway = game.typeMatchup.where === "away";
    const opponentAbbreviation = game.typeMatchup.opponent.abbreviation;

    return isAway ? `@ ${opponentAbbreviation}` : `vs ${opponentAbbreviation}`;
  }

  if (game.typeEvent) {
    return game.typeEvent.name;
  }

  throw new TypeError("Missing event or matchup details");
}
